import {
  service,
  BASE_API
} from '@/utils/request'
const baseUrl = BASE_API
const v2 = BASE_API

export default {
  //获取问诊订单列表
  getOrderList: (params) => {
    return service({
      url: '/cloud/consult/v1/consult/getOrderPage',
      method: 'get',
      params: params
    })
  },
  //获取统计数据
  getTotalData: (params) => {
    return service({
      url: '/cloud/consult/v1/consult/getOrderTotal',
      method: 'get',
      params: params
    })
  },
  //导出excel
  getExportUrl: (query) => {
    return baseUrl + '/cloud/consult/v1/consult/exportOrder' + query
  },
  //获取详情
  getOrderDetailApi: (params) => {
    return service({
      url: '/cloud/consult/v1/consult/getOrderDetail',
      method: 'get',
      params: params
    })
  },
  //获取普通聊天历史
  getNormalChatListApi: (params) => {
    return service({
      url: '/cloud/consult/v1/consult/getChatListPage',
      method: 'get',
      params: params
    })
  },
  //获取电话聊天历史
  getPhoneChatListApi: (params) => {
    return service({
      url: '/cloud/consult/v1/consult/getPhoneChatListPage',
      method: 'get',
      params: params
    })
  },
   //退款
   refundsApi: (data) => {
    return service({
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest : [function (data) {
        let newData = ''
        for (let k in data) {
          newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
        }
        return newData
      }],
      url: '/cloud/consult/v1/consult/batchRefunds',
      method: 'post',
      data: data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/diagnosisOrder.js